import { Field, reduxForm } from 'redux-form/immutable';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '../../../ui/Button';
import Form from '../../../ui/Form';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '../../../ui/Input';
import Alert from "../../../ui/Alert";

const renderInputField = field => {
    return (<Input {...field.input} disabled={field.disabled} />);
};

@injectIntl
export class OrderTrackingForm extends Component {
    /* eslint-enable */
    static propTypes = {
        handleSubmit: PropTypes.func,
        submitting: PropTypes.bool,
        submitFailed: PropTypes.bool,
    };

    render() {
        const { handleSubmit, submitting, submitFailed } = this.props;

        return (
            <Form onSubmit={handleSubmit}>
                <Form.Control>
                    {
                        submitFailed && (<Alert type='warning'>
                            <FormattedMessage id='frontend.orders.tracking.order_not_found' />
                        </Alert>)
                    }

                    <br/>
                    <Form.Label>
                        <FormattedMessage id='frontend.orders.tracking.input'/>
                    </Form.Label>

                    <Field name='code' component={renderInputField} props={{disabled: submitting}} />
                    <Form.Hint>
                        <FormattedMessage id='frontend.orders.tracking.hint'/>
                    </Form.Hint>
                </Form.Control>
                <br />
                <Button emphasis='primary' type='submit' disabled={submitting}>
                    <FormattedMessage id='frontend.orders.tracking.order_search'/>
                </Button>
            </Form>);
    }
}

export default reduxForm({
    form: 'order.tracking',
})(OrderTrackingForm);
